





































































import { Component, Prop, Vue } from 'vue-property-decorator';

import { State, Mutation, namespace } from 'vuex-class';



const appModule = namespace('app');

import HeaderUser from './Header.User.vue';
import HeaderNotify from './Header.Notify.vue';
import HeaderSearch from './Header.Search.vue';
import SelectLange from './SelectLange.vue';

@Component({
  components: {
    HeaderUser,
    HeaderNotify,
    HeaderSearch,
    SelectLange,
  },
})
export default class AdminHeader extends Vue {

  @appModule.State('isCollapse')
  private isCollapse!: boolean;

  @appModule.Mutation('collapse')
  private collapse!: () => void;

  private handlerCollapsedSidebar( ): void {
    this.collapse();
  }



  private mounted() {
  }
}
